import React from 'react';
import { useSelectIsAppModeNewportSingleWidget } from 'app/store/general/selectors';
import { Dropdown } from '@instinet-analytics/semantic-ui-components';
import { bucketDropDownValues } from '../store/configuration/IntraDayProfileConfiguration';
import './IntraDayProfileSettings.scss';
import AppSettingsEditor from 'appToolbar/AppSettingsEditor';
import { useSelectAppSettings } from 'app/store/appSettings/selectors';
import { useDispatchUpdateAppSettings } from 'app/store/appSettings/dispatcher';
import { buildIntraDayProfileConfigSlice } from 'widgets/intraDayProfile/store/configuration/configSlice';

const {
    hooks: { useDispatchUpdateConfigAction },
} = buildIntraDayProfileConfigSlice();

export interface IntraDayProfileSettingsProps {
    bucketSize: number;
}

export default function IntraDayProfileSettings(
    props: IntraDayProfileSettingsProps
) {
    const { bucketSize } = props;

    const isAppModeNewportSingleWidget =
        useSelectIsAppModeNewportSingleWidget();
    const appSettings = useSelectAppSettings();
    const dispatchUpdateAppSettings = useDispatchUpdateAppSettings();

    const dropDownValues = bucketDropDownValues.map((value) => ({
        text: value.toString(),
        value,
    }));

    const dispatchIntraDayProfileConfigUpdate = useDispatchUpdateConfigAction();

    const onBucketSizeChanged = (bucketSize: number) => {
        dispatchIntraDayProfileConfigUpdate({ bucketSize });
    };

    return (
        <div className="IntraDayProfileSettings">
            <div className="group group-general">
                <div className="group-header">
                    <div className="title">Time Buckets</div>
                </div>
                <div>Exp Vol and Act Vol time buckets in minutes</div>
                <div>
                    <Dropdown
                        className={'bucket-size-dropdown'}
                        options={dropDownValues}
                        value={bucketSize}
                        onChange={onBucketSizeChanged}
                    />
                </div>
            </div>
            {isAppModeNewportSingleWidget && (
                <AppSettingsEditor
                    appSettings={appSettings}
                    onAppSettingsChanged={dispatchUpdateAppSettings}
                    specifyVisibleControls={{
                        showChartHelp: true,
                        showTooltips: true,
                    }}
                />
            )}
        </div>
    );
}
